import capaCredenciados from '@/ui/assets/hero-credenciados.jpg';
import capaDadosPublicos from '@/ui/assets/hero-dados-publicos.jpg';
import capaInicio from '@/ui/assets/hero-landing.jpg';
import capaLegislacao from '@/ui/assets/hero-legislacao.jpg';
import capaPrivacidade from '@/ui/assets/hero-privacidade.jpg';
import capaPrograma from '@/ui/assets/hero-programa.jpg';
import capaTermos from '@/ui/assets/hero-termos.jpg';
import capaTransportadores from '@/ui/assets/hero-transportadores.jpg';

/**
 * Foto de fundo do cabeçalho de cada página pública, por slug.
 *
 * O cabeçalho do portal é foto com véu da cor primária por cima (`PortalHero`),
 * e a foto muda de página para página. Enquanto a API de conteúdo não responde,
 * `hero_imagem_url` chega nulo em toda página — sem este mapa o cabeçalho ficava
 * liso, que é o que diferia da interface de referência.
 *
 * Quando a página gravada trouxer `hero_imagem_url`, ela vence: isto é só o
 * padrão de cada endereço, não substituto do conteúdo editorial.
 */
export const CAPAS_POR_SLUG: Readonly<Record<string, string>> = {
  inicio: capaInicio,
  programa: capaPrograma,
  credenciados: capaTransportadores,
  'dados-publicos': capaDadosPublicos,
  transparencia: capaDadosPublicos,
  legislacao: capaLegislacao,
  privacidade: capaPrivacidade,
  'termos-de-uso': capaTermos,
};

/** Capa de um slug; quem não tem a sua cai na de "Sobre o TEG", como na referência. */
export function capaDaPagina(slug: string): string {
  return CAPAS_POR_SLUG[slug] ?? capaPrograma;
}

/**
 * Páginas cujo cabeçalho é mais baixo — as de texto corrido, em que a foto não
 * precisa do mesmo peso das duas páginas de entrada ("Sobre o TEG" e "Para
 * credenciados"). Mesmo recorte da interface de referência.
 */
const SLUGS_DE_CABECALHO_BAIXO: readonly string[] = [
  'legislacao',
  'dados-publicos',
  'transparencia',
  'privacidade',
  'termos-de-uso',
];

/** Diz se o cabeçalho da página é o baixo. */
export function cabecalhoBaixo(slug: string): boolean {
  return SLUGS_DE_CABECALHO_BAIXO.includes(slug);
}

/** Capa da consulta pública de credenciados, que não é página editorial. */
export const CAPA_CONSULTA_DE_CREDENCIADOS = capaCredenciados;

/** Capa do aviso de privacidade, que é tela própria e não página editorial. */
export const CAPA_PRIVACIDADE = capaPrivacidade;
